import axios from 'axios';
import { loginreq, req } from './axiosFun';
import { getHttpParams } from '../utils/util';

// 站点名称
export const getStationNames = (params) => { return req("get", "/admin/station_names") };

// 站点列表
export const getStation = (params) => { return req("get", "/admin/station?"+getHttpParams(params)) };

//新增
export const addStation = (params) => { return req("get", "/admin/station/create?"+getHttpParams(params)) };


export const updateStation = (id, params) => { return req("patch", "/admin/station/"+id+'?'+getHttpParams(params)) };


export const deleteStation = (id) => { return req("delete", "/admin/station/"+id) };


export const handleInfo = (id) => { return req("get", "/admin/handleInfo/"+id) };

export const getPlateStatus = (params) => { return req("get", "/admin/getPlateStatus?"+getHttpParams(params)) };

export const sendCoupon = (params) => { return req("get", "/admin/sendCoupon?"+getHttpParams(params)) };

export const listCoupon = (params) => { return req("get", "/admin/listCoupon?"+getHttpParams(params)) };





// WEBPACK FOOTER //
// ./src/api/station.js